/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ClientSurveyQuestionModel } from '../../models/client-survey-question-model';

export interface GetSurveyQuestions$Json$Params {

/**
 * surveytype id filter
 */
  surveyTypeId: number;
}

export function getSurveyQuestions$Json(http: HttpClient, rootUrl: string, params: GetSurveyQuestions$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ClientSurveyQuestionModel>>> {
  const rb = new RequestBuilder(rootUrl, getSurveyQuestions$Json.PATH, 'get');
  if (params) {
    rb.query('surveyTypeId', params.surveyTypeId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ClientSurveyQuestionModel>>;
    })
  );
}

getSurveyQuestions$Json.PATH = '/api/SurveyQuestion';
